'use strict';

const {countdown} = require('./activity-countdown.js');
const MAX_REWARD_TITLE = '最高可獲得 22,200 OP 幣';
const MAX_REWARD_NOTE = '依揭卡結果獲得獎勵，最高獎勵並非每包保證獲得。';

// The published monitor carries the server-adjusted clock. Never invent an end
// date, restart a campaign timer, or use nextStep as proof that sales are active.
function activityPresentation(activity, publishedClock, now = Date.now()) {
  const valid = activity && typeof activity.activityId === 'string' && activity.enabled === true &&
    Number.isSafeInteger(activity.startAt) && Number.isSafeInteger(activity.endAt) &&
    activity.startAt >= 0 && activity.endAt > activity.startAt;
  if (!valid) return {active: false, phase: 'unavailable', countdown: '00:00:00', remainingMs: 0, endLabel: ''};
  const ending = {endAt: activity.endAt, endLabel: new Date(activity.endAt + 28800000).toISOString().slice(0, 16).replace('T', ' ')};
  let clock = now;
  if (publishedClock !== undefined) {
    const published = publishedClock && publishedClock.activity;
    if (!published || published.activityId !== activity.activityId || published.startAt !== activity.startAt ||
        published.endAt !== activity.endAt || !Number.isFinite(publishedClock.remainingMs) || publishedClock.remainingMs <= 0) {
      return {active: false, phase: now >= activity.endAt ? 'ended' : 'unavailable', countdown: '00:00:00', remainingMs: 0, ...ending};
    }
    clock = activity.endAt - publishedClock.remainingMs;
  }
  const phase = clock < activity.startAt ? 'future' : clock >= activity.endAt ? 'ended' : 'active';
  const remainingMs = phase === 'active' ? activity.endAt - clock : 0;
  return {active: phase === 'active', phase, remainingMs, countdown: countdown(remainingMs), ...ending};
}

module.exports = {activityPresentation, MAX_REWARD_TITLE, MAX_REWARD_NOTE};
